const RatedPower_Icon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="13" fill="#F2F8F6" />
      <path
        d="M16 10.75V14.245L13.375 16.8775V18.25H12.625V16.8775L10 14.2375V10.75H16ZM16 6.25H14.5V9.25H11.5V6.25H10V9.25H9.9925C9.175 9.2425 8.5 9.9175 8.5 10.735V14.875L11.125 17.5V19.75H14.875V17.5L17.5 14.8675V10.75C17.5 9.925 16.825 9.25 16 9.25V6.25Z"
        fill="#79C8B0"
      />
      <path
        d="M16 10.75V14.245L13.375 16.8775V18.25H12.625V16.8775L10 14.2375V10.75H16ZM16 6.25H14.5V9.25H11.5V6.25H10V9.25H9.9925C9.175 9.2425 8.5 9.9175 8.5 10.735V14.875L11.125 17.5V19.75H14.875V17.5L17.5 14.8675V10.75C17.5 9.925 16.825 9.25 16 9.25V6.25Z"
        fill="url(#paint0_linear_1930_3107)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1930_3107"
          x1="15.8125"
          y1="17.5"
          x2="8.72235"
          y2="13.0202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default RatedPower_Icon;
